import { loginRes } from '../Login.res';

export const res = {
  reject: {
    ...loginRes.reject,
  } as const,
};
